export enum StatType {
  Content = 'CONTENT  ',
  Section = 'SECTION',
  Skill = 'SKILL',
}

/**
 * Marks a user's completion of a specific target (skill, section, etc.). The existence of a stat in the database
 * signifies that the user (pointed to by userUid) has completed the target with id targetID.
 */
export interface BaseStatData {
  id: string;
  targetId: string;
  userUid: string;
  /**
   * Module id of the module which this target is under. If this target refers to a module, this value is the same as
   * targetId. This field is mainly used for firebase query-purposes.
   */
  skillId: string;
  created: Date;
}

/**
 * Marks a user's completion of a section.
 */
export type ContentStatData = BaseStatData & { type: StatType.Content };

/**
 * Marks a user's completion of a skill.
 */
export type SectionStatData = BaseStatData & { type: StatType.Section };

/**
 * Marks a user's completion of a module.
 */
export type SkillStatData = BaseStatData & { type: StatType.Skill };

export type StatData = ContentStatData | SectionStatData | SkillStatData;
